module.exports = __webpack_public_path__ + "img/DB1GROUP_LOGO.c945aee9.png";